<script>
'use strict';

module.exports = {
  name: 'SkeletonStoryCard',
};
</script>

<template>
  <div class="story-card skeleton-story-card">
    <div class="skeleton-image skeleton-image-square skeleton-pulse"></div>
    <div class="skeleton-story-details">
      <div class="skeleton-line skeleton-line-meta skeleton-pulse"></div>
      <div class="skeleton-line skeleton-line-headline skeleton-pulse"></div>
      <div class="skeleton-line skeleton-line-headline-short skeleton-pulse"></div>
    </div>
  </div>
</template>

<style scoped lang="postcss"></style>
